import {useLocation, useNavigate} from "react-router-dom";
import Header from "./Header";
import '../css/Game.css'
import {generateDrinks, generateTasks} from "../services/ListService";
import arrayShuffle from "array-shuffle";
import {useEffect, useState} from "react";
import Rules from "./Rules";
import Terms from "./Terms";
import hamburgerIcon from "../icons/hamburger-pineapplespin.png";
import Footer from "./Footer";
import bottle from '../icons/bottle.png'
import nacho from '../icons/nacho.png'

function generateTurns(length) {
    const turns = [];
    for (let i = 0; i < length; i++) {
        turns.push(i);
    }
    return turns;
}

function shuffleTurns(turns) {
    return arrayShuffle(turns);
}

function shuffleTasks(tasks) {
    return arrayShuffle(tasks);
}

function shuffleDrinks(drinks) {
    return arrayShuffle(drinks);
}

const bounce = 'bounce 1s linear infinite';
const littleBounce = 'littleBounce 1s linear infinite';
const spin = 'spin 1s linear 3'
const bottleSpin = 2000;
const bottleTimeout = 100;


function Game() {
    const {state} = useLocation();
    const navigate = useNavigate();
    const savedState = JSON.parse(localStorage.getItem('nachoSpinState'));
    const score = (state != null && state.game != null) ? state.game.score : savedState ? savedState.score : 5;
    const edition = (state != null && state.game != null) ? state.game.edition : savedState ? savedState.score : 'bar';


    const placeHolderPlayers = [
        {
            id: 0,
            placeHolder: 'Player 1',
            name: 'Player 1',
        },
        {
            id: 1,
            placeHolder: 'Player 2',
            name: 'Player 2',
        }
    ]
    const players = (state != null && state.game != null) ? state.game.players : savedState ? savedState.players : placeHolderPlayers;


    function getGame() {
        if (state != null) {
            return state.game;
        } else {
            return {
                players: [
                    {
                        id: 0,
                        placeHolder: 'Player 1',
                        name: 'Player 1',
                        score: 0
                    },
                    {
                        id: 1,
                        placeHolder: 'Player 2',
                        name: 'Player 2',
                        score: 0
                    }
                ],
                score: 5,
                edition: 'bar'
            }
        }
    }

    useEffect(() => {
        if (state == null && savedState == null) {
            localStorage.removeItem('nachoSpinState');
            navigate("/");
        } else {
            window.scrollTo({
                top: 0,
            });
        }
    }, []);

    // let [round, setRound] = useState(1);
    // const [players] = useState(getGame().players);
    // let [turns, setTurns] = useState(shuffleTurns(generateTurns(getGame().players.length)));
    // let [roundCounter, setRoundCounter] = useState(0);
    // let [taskCounter, setTaskCounter] = useState(0);
    // let [drinkCounter, setDrinkCounter] = useState(0);
    // let [player, setPlayer] = useState(getGame().players[turns[roundCounter]]);
    // let [taskHelper, setTaskHelper] = useState(getRandomPlayer(player));
    // let [drinkHelper, setDrinkHelper] = useState(getRandomPlayer(player));
    // let [tasks, setTasks] = useState(shuffleTasks(generateTasks(getGame().edition)));
    // let [drinks, setDrinks] = useState(shuffleDrinks(generateDrinks(getGame().edition)));
    // const [winningScore] = useState(getGame().score);
    // const [agreed, setAgreed] = useState(false);
    // const [accepted, setAccepted] = useState(false);
    // const [rulesVisibility, setRulesVisibility] = useState(false);
    // const [gameVisibility, setGameVisibility] = useState("block");
    // const [ruleGame, setRuleGame] = useState("Rules")
    // const [newGame, setNewGame] = useState(false);

    const [hamburgerDisplay, setHamburgerDisplay] = useState("0");
    const [hamburgerRightBorder, setHamburgerRightBorder] = useState("none");
    const [hamburgerBottomBorder, setHamburgerBottomBorder] = useState("none");

    const [isRules, setIsRules] = useState(false);

    // const [bottleButtonDisabled, setBottleButtonDisabled] = useState(false);
    // const [bottleButtonVisible, setBottleButtonVisible] = useState('');
    // const [taskBodyVisible, setTaskBodyVisible] = useState('hidden');

    // const [initialFade, setInitialFade] = useState(false);

    const initialTasks = savedState ? '' : shuffleTasks(generateTasks(getGame().edition));
    const initialDrinks = savedState ? '' : shuffleTasks(generateDrinks(getGame().edition));
    const initialTurns = savedState ? '' : shuffleTurns(generateTurns(getGame().players.length));
    const initialPlayer = savedState ? '' : getGame().players[initialTurns[0]];
    const initialTaskHelper = savedState ? '' : getRandomPlayer(initialPlayer);
    const initialDrinkHelper = savedState ? '' : getRandomPlayer(initialPlayer);

    // Initialize state with both tasks and task
    let [appState, setAppState] = useState(savedState || {
        bottleAnimation: bounce,
        round: 1,
        players: getGame().players,
        winningScore: getGame().score,
        edition: getGame().edition,
        turns: initialTurns,
        roundCounter: 0,
        taskCounter: 0,
        drinkCounter: 0,
        tasks: initialTasks,
        task: initialTasks[0], // Set initial task based on calculated tasks
        player: initialPlayer, // Assuming players array is not empty
        drinkHelper: initialDrinkHelper,
        drinks: initialDrinks,
        rulesVisibility: false,
        gameVisibility: 'block',
        ruleGame: 'Rules',
        newGame: false,
        bottleButtonDisabled: false,
        bottleButtonVisible: '',
        taskBodyVisible: 'hidden',
        initialFade: false,
        // spinOrTask: spinPineapple,
        turnCounter: 0,
        taskHelper: initialTaskHelper, // Assuming players array is not empty
        consents: false,
        playerConsent: false,
        helperConsent: false,
        playerDrinks: false,
        helperDrinks: false,
        // roundSwitcher: getRoundSwitcher(),
        // gameEnder: getGameEnder(),
        agreed: false,
        accepted: false,
        playerFade: false,
        roundFade: false,
        fade: false,
        termsFade: false,
        bottleFade: false,
        taskBodyFade: false,
        spinTaskFade: false,
        narratorFade: false
    });

    useEffect(() => {
        if (state != null || savedState != null) {
            localStorage.setItem('nachoSpinState', JSON.stringify(appState));
        }

    }, [appState]);

    function changeState(property, value) {
        setAppState(prevState => ({
            ...prevState,
            [property]: value
        }));
    }


    useEffect(() => {
        changeState('initialFade', true);
        window.scrollTo({
            top: 0,
        });
        setTimeout(() => {
            changeState('initialFade', false);
        }, 10);
    }, [appState.accepted, isRules]);

    const [termsFade, setTermsFade] = useState(false);
    useEffect(() => {
        setTermsFade(true);
        setTimeout(() => {
            setTermsFade(false);
        }, 10);
    }, [appState.accepted, isRules]);

    useEffect(() => {
        changeState('fade', true);
        setTimeout(() => {
            changeState('fade', false);
        }, 10);
    }, [appState.roundCounter]);

    useEffect(() => {
        changeState('roundFade', true);
        setTimeout(() => {
            changeState('roundFade', false);
        }, 10);
    }, [appState.round]);

    function navClick(_selection) {
        handleHamburgerCancel();
        switch (_selection) {
            case "rules":
                changeState('agreed', false);
                setIsRules(true);
                break;
            case "back":
                changeState('agreed', false);
                setIsRules(false);
                break;
            case "new":
                changeState('agreed', false);
                if (window.confirm("Leave current game?")) {
                    localStorage.removeItem('nachoSpinState');
                    navigate("/");
                }
                break;
            default:
        }
    }

    function handleHamburgerDisplay() {
        if (hamburgerDisplay === "0") {
            setHamburgerDisplay("50%");
            setHamburgerRightBorder("solid 3px black");
            setHamburgerBottomBorder("solid 3px black");
        } else {
            handleHamburgerCancel();
        }
    }

    function handleHamburgerCancel() {
        setHamburgerDisplay("0");
        setHamburgerRightBorder("none");
        setHamburgerBottomBorder("none");
        // setPlayersWidth('0');
        // setPlayersPadding('0');
        // setCollapseButtonRight('0');
        // setCollapseButton('<');
    }

    const [playersWidth, setPlayersWidth] = useState('0');
    const [playersPadding, setPlayersPadding] = useState('0');
    const [collapseButtonRight, setCollapseButtonRight] = useState('0');
    const [collapseButton, setCollapseButton] = useState('<');


    function handlePlayersClick() {
        if (playersWidth === '0') {
            setPlayersWidth('25%');
            setPlayersPadding('0 12px');
            setCollapseButtonRight('25%');
            setCollapseButton('>');
        } else {
            setPlayersWidth('0');
            setPlayersPadding('0');
            setCollapseButtonRight('0');
            setCollapseButton('<');
        }
    }

    const displayPlayers = (
        <div className={"player-list"} style={{padding: playersPadding}}>
            {[...appState.players].sort((a, b) => a.score > b.score ? -1 : 1).map(player => (
                <li className={"player"} key={player.id}><span
                    className={"player-name"}>{player.name.toLowerCase()}</span><span
                    className={"player-score"}>{player.score}</span></li>
            ))}
        </div>
    )

    function handleClick(choice) {
        if (choice === 'task') {
            appState.player.score += 2;
        } else if (choice === 'drink') {
            appState.player.score += 1
        }

        if (appState.player.score >= appState.winningScore) {
            localStorage.removeItem('nachoSpinState');
            navigate("/winner", {state: {winner: appState.player, edition: appState.edition}})
        }

        if (appState.roundCounter < appState.players.length - 1) {
            appState.roundCounter++;
            changeState('roundCounter', appState.roundCounter);
        } else {
            appState.roundCounter = 0;
            changeState('roundCounter', appState.roundCounter);

            appState.round++;
            changeState('round', appState.round);

            appState.turns = shuffleTurns(appState.turns);
            changeState('turns', appState.turns);
        }
        if (appState.taskCounter < appState.tasks.length - 1) {
            appState.taskCounter++;
            changeState('taskCounter', appState.taskCounter);
        } else {
            appState.tasks = shuffleTasks(appState.tasks);
            changeState('tasks', appState.tasks);

            appState.taskCounter = 0;
            changeState('taskCounter', appState.taskCounter);
        }
        if (appState.drinkCounter < appState.drinks.length - 1) {
            appState.drinkCounter++;
            changeState('drinkCounter', appState.drinkCounter);
        } else {
            appState.drinks = shuffleDrinks(appState.drinks);
            changeState('drinks', appState.drinks);

            appState.drinkCounter = 0;
            changeState('drinkCounter', appState.drinkCounter);
        }

        appState.player = appState.players[appState.turns[appState.roundCounter]];
        changeState('player', appState.player);
        changeState('taskHelper', getRandomPlayer(appState.player));
        changeState('drinkHelper', getRandomPlayer(appState.player));

        handleTaskBottleSwitch();
    }

    function verifyTask(task) {
        if (task.includes('*')) {
            // task = task.replace('*', getRandomPlayer(player));
            task = task.replace('*', appState.taskHelper);
        }
        return task;
    }

    function verifyDrink(drink) {
        if (drink.includes('*')) {
            // drink = drink.replace('*', getRandomPlayer(player));
            drink = drink.replace('*', appState.drinkHelper);
        }
        return drink;
    }

    function getRandomPlayer(player) {
        let randomNumber;
        let time = new Date().getTime();
        if (time % 3 === 0) {
            randomNumber = Math.floor(Math.random() * players.length);
        } else if (time % 2 === 0) {
            const Chance = require('chance');
            const chance = new Chance();
            randomNumber = chance.integer({min: 0, max: players.length - 1});
        } else {
            const randomBuffer = new Uint32Array(1);
            crypto.getRandomValues(randomBuffer);
            randomNumber = randomBuffer[0] % players.length;
        }
        if (player.id === randomNumber) {
            return getRandomPlayer(player);
        } else {
            return players[randomNumber].name;
        }
    }

    function getDrinkHeading() {
        return appState.edition === 'bar' ? 'Your Shot' : 'Your Drink';
    }

    function getDrinkButton() {
        return appState.edition === 'bar' ? 'Shot Taken' : 'Drink Complete';
    }

    // function showRules() {
    //     setGameVisibility(gameVisibility === "none" ? "block" : "none");
    //     setRulesVisibility(!rulesVisibility);
    //     setRuleGame(ruleGame === "Rules" ? "Back" : "Rules")
    //     setNewGame(!newGame);
    // }

    function verifyTerms() {
        if (appState.agreed) {
            changeState('accepted', true);
            window.scrollTo({
                top: 0,
            });
        } else {
            alert('You must check the box, acknowledging that each player has read, understands, and agrees to all of the terms present on this screen.')
        }
    }

    const hamburger = (
        <button onClick={() => handleHamburgerDisplay()} className={"hamburger-button"}><img
            className={"hamburger-icon"}
            src={hamburgerIcon}
            alt={"hamburgerIcon"}/></button>
    )

    const backButton = (
        <button type={"button"} className={"back"}
                onClick={() => {
                    setIsRules(false);
                    window.scrollTo({
                        top: 0,
                    });
                }}>Back</button>
    )

    const navMenu = (
        <div className={"hamburger-menu"}
             style={{width: hamburgerDisplay, borderRight: hamburgerRightBorder, borderBottom: hamburgerBottomBorder}}>
            <button type={"button"} className={"hamburger-cancel"} onClick={() => handleHamburgerCancel()}>x</button>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("rules")}>Rules
                </button>
            </div>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("new")}>New Game
                </button>
            </div>
        </div>
    )

    const rulesNavMenu = (
        <div className={"hamburger-menu"}
             style={{width: hamburgerDisplay, borderRight: hamburgerRightBorder, borderBottom: hamburgerBottomBorder}}>
            <button type={"button"} className={"hamburger-cancel"} onClick={() => handleHamburgerCancel()}>x</button>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("back")}>Back
                </button>
            </div>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("new")}>New Game
                </button>
            </div>
        </div>
    )

    useEffect(() => {
        changeState('bottleFade', true);
        setTimeout(() => {
            changeState('bottleFade', false);
        }, 10);
    }, [appState.roundCounter, appState.bottleButtonVisible]);


    function handleBottleClick() {
        changeState('bottleAnimation', spin);
        changeState('bottleButtonDisabled', true);
        setTimeout(() => {
            changeState('bottleButtonVisible', 'hidden');
            setTimeout(() => {
                changeState('taskBodyVisible', '');
            }, 100)
        }, bottleSpin)
    }

    useEffect(() => {
        changeState('taskBodyFade', true);
        setTimeout(() => {
            changeState('taskBodyFade', false);
        }, 10);
    }, [appState.taskBodyVisible]);

    function handleTaskBottleSwitch() {
        changeState('bottleAnimation', bounce);
        changeState('bottleButtonDisabled', false);
        changeState('taskBodyVisible', 'hidden')
        setTimeout(() => {
            changeState('bottleButtonVisible', '')
        }, bottleTimeout)
    }

    function getFontSize() {
        if (appState.edition === 'home') {
            return '20px';
        }
    }

    const [rulesFade, setRulesFade] = useState(false);
    useEffect(() => {
        setRulesFade(true);
        setTimeout(() => {
            setRulesFade(false);
        }, 10);
    }, [isRules]);

    if (!appState.accepted) {
        return isRules ? (
            <div className={"rules-container"}>
                <Header hamburger={hamburger} gameInProgress={true}/>
                {rulesNavMenu}
                <div className={rulesFade ? 'fade-out' : 'fade-in'}>
                    <Rules edition={appState.edition} back={backButton}/>
                </div>
                <Footer/>
            </div>
        ) : (
            <div className={"terms"}>
                <Header hamburger={hamburger} gameInProgress={true}></Header>
                {navMenu}
                <div className={`terms-container ${termsFade ? 'fade-out' : 'fade-in'}`}
                     onClick={() => handleHamburgerCancel()}>
                    <Terms/>
                    <div className={"agree-container"}>
                        <div className={"agree-checkbox-container"}>
                            <input id={"agree-checkbox"} type={"checkbox"}
                                   onChange={() => changeState('agreed', document.getElementById('agree-checkbox').checked)}/>
                        </div>
                        <div className={"disclaimer-container"}>
                            <div className={"disclaimer"}>Each player has read, understands, and agrees to all of the
                                terms present
                                on this screen.
                            </div>
                        </div>
                    </div>
                    <div className={"agree-button-container"}>
                        <button type={"button"} className={"agree-button"} style={{animation: bounce}}
                                onClick={() => verifyTerms()}>Let's Go!
                        </button>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    } else {
        return isRules ? (
            <div className={"rules-container"}>
                <Header hamburger={hamburger} gameInProgress={true}/>
                {rulesNavMenu}
                <div className={rulesFade ? 'fade-out' : 'fade-in'}>
                    <Rules edition={appState.edition} back={backButton}/>
                </div>
                <Footer/>
            </div>
        ) : (
            <div className={"game"}>
                <Header hamburger={hamburger} gameInProgress={true}/>
                {navMenu}
                <div className={"players-list-wrapper"}>
                    <div className={"collapse-button"} style={{right: collapseButtonRight}} onClick={() => handlePlayersClick()}>{collapseButton}</div>
                    <div className={"players-list-container"} style={{width: playersWidth}}>
                        {displayPlayers}
                    </div>
                </div>
                <div className={`game-body ${appState.initialFade ? 'fade-out' : 'fade-in'}`}
                     style={{display: appState.gameVisibility}}
                     onClick={handleHamburgerCancel}>
                    {/*<div className={"score-round-players"}>*/}
                    {/*    <div className={"score-round-container"}>*/}
                    <div className={"round"}>Round: <span
                        className={`${appState.roundFade ? 'fade-out' : 'fade-in'} round-number`}>
                                    {appState.round}</span></div>
                    <div className={"winning-score"}>First player to {appState.winningScore} wins!</div>

                    {/*</div>*/}
                    {/*</div>*/}
                    <h1 className={`${appState.fade ? 'fade-out' : 'fade-in'} current-player`}>{appState.player.name}</h1>
                    <div className={`${appState.bottleFade ? 'fade-out' : 'fade-in'} bottle-button-container`}
                         style={{visibility: appState.bottleButtonVisible}}>
                        <div className={"spin-text"}>Spin the nacho</div>
                        <button disabled={appState.bottleButtonDisabled} onClick={() => handleBottleClick()}
                                className={"bottle-button"}>
                            <img className={"bottle"} style={{animation: appState.bottleAnimation}} src={nacho}
                                 alt="bottle"/>
                        </button>
                    </div>
                    <div className={`task-drink-container ${appState.taskBodyFade ? 'fade-out' : 'fade-in'}`}
                         style={{visibility: appState.taskBodyVisible}}>
                        <div className={"task-container"}>
                            <h1 className={"task-heading"}>Your Task</h1>
                            <div
                                className={`${appState.fade ? 'fade-out' : 'fade-in'} task-body`}>
                                {verifyTask(appState.tasks[appState.taskCounter])}
                            </div>
                        </div>
                        <div className={"drink-container"}>
                            <h1 className={"drink-heading"}>{getDrinkHeading()}</h1>
                            <div className={`${appState.fade ? 'fade-out' : 'fade-in'} drink-body`}
                                 style={{fontSize: getFontSize()}}>
                                {verifyDrink(appState.drinks[appState.drinkCounter])}
                            </div>
                        </div>
                        <button className="task-complete complete-button"
                                onClick={() => handleClick('task')}>
                            <div style={{animation: bounce}}>
                                <div>Task Complete</div>
                                <div className={"points-received"}>2 Points!</div>
                            </div>
                        </button>
                        <button className="drink-complete complete-button"
                                onClick={() => handleClick('drink')}>
                            <div style={{animation: bounce}}>
                                <div>{getDrinkButton()}</div>
                                <div className={"points-received"}>1 Point!</div>
                            </div>
                        </button>
                        <button className={"pass complete-button"}
                                onClick={() => handleClick('pass')}>
                            <div style={{animation: bounce}}>
                                <div>Pass</div>
                            </div>
                        </button>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Game;